import { ref, watch } from 'vue'

import type { TagName } from '@/types'
import { useTagsStorage } from '@/use'

export default function useDefaultTags(key: string) {
  const { get, set } = useTagsStorage(key)
  const tags = ref<TagName[]>([...get()])

  watch(tags, (value) => {
    set(new Set(value))
  })

  return { tags }
}
